"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAttributeFilterParents = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var differenceBy_1 = tslib_1.__importDefault(require("lodash/differenceBy"));
var zip_1 = tslib_1.__importDefault(require("lodash/zip"));
var sdk_model_1 = require("@gooddata/sdk-model");
function validateAttributeFilterParents(ctx, dashboardFilter, parents, allFilters, displayFormsMap) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var allExceptValidated, allExceptValidatedLocalIds, hasExtraneousParent, parentValidationData, commonAttributeResults, validationPairs, areAllConnectionsValid;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    allExceptValidated = allFilters.filter(function (item) {
                        return !sdk_model_1.areObjRefsEqual(item.attributeFilter.displayForm, dashboardFilter.attributeFilter.displayForm);
                    });
                    allExceptValidatedLocalIds = allExceptValidated.map(function (item) { return item.attributeFilter.localIdentifier; });
                    hasExtraneousParent = parents.some(function (parent) { return !allExceptValidatedLocalIds.includes(parent.filterLocalIdentifier); });
                    if (hasExtraneousParent) {
                        return [2 /*return*/, "EXTRANEOUS_PARENT"];
                    }
                    parentValidationData = parents.map(function (parent) {
                        var _a, _b;
                        var parentFilter = allExceptValidated.find(function (item) { return item.attributeFilter.localIdentifier === parent.filterLocalIdentifier; }); // the ! is cool here, we validated that the parents are available in the code above
                        var parentAttribute = (_a = displayFormsMap.get(parentFilter.attributeFilter.displayForm)) === null || _a === void 0 ? void 0 : _a.attribute;
                        var dashboardFilterAttribute = (_b = displayFormsMap.get(dashboardFilter.attributeFilter.displayForm)) === null || _b === void 0 ? void 0 : _b.attribute;
                        if (!parentAttribute || !dashboardFilterAttribute) {
                            return undefined;
                        }
                        return {
                            parentOverAttributes: parent.over.attributes,
                            displayFormsToGetAncestorsFor: [dashboardFilterAttribute, parentAttribute],
                        };
                    });
                    if (parentValidationData.some(function (parent) { return parent === undefined; })) {
                        return [2 /*return*/, "INVALID_METADATA"];
                    }
                    return [4 /*yield*/, ctx.backend
                            .workspace(ctx.workspace)
                            .attributes()
                            // the ! is fine here, we validated parentValidationData for empty items above
                            .getCommonAttributesBatch(parentValidationData.map(function (item) { return item.displayFormsToGetAncestorsFor; }))];
                case 1:
                    commonAttributeResults = _a.sent();
                    validationPairs = zip_1.default(parentValidationData.map(function (item) { return item.parentOverAttributes; }), commonAttributeResults);
                    areAllConnectionsValid = validationPairs.every(function (_a) {
                        var _b = tslib_1.__read(_a, 2), parentOverAttributes = _b[0], connectingAttrs = _b[1];
                        return differenceBy_1.default(parentOverAttributes, connectingAttrs, sdk_model_1.objRefToString).length === 0;
                    });
                    return [2 /*return*/, areAllConnectionsValid ? "VALID" : "INVALID_CONNECTION"];
            }
        });
    });
}
exports.validateAttributeFilterParents = validateAttributeFilterParents;
//# sourceMappingURL=parentFiltersValidation.js.map